<template>
  <div class="bg-gray-100 py-24 sm:py-32 relative">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <h2 class="text-center text-3xl font-bold text-gray-900 mb-12">Client Testimonials</h2>

      <div class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
        <!-- Testimonial 1 -->
        <div class="bg-white p-6 rounded-lg shadow-lg text-gray-900 relative">
          <div class="absolute top-[0px] left-[0px] flex flex-col">
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
          </div>
          <p class="text-lg font-medium">"Every team member I interacted with was an expert in their field and showed great commitment. Thanks to them, building our home was stress-free and enjoyable."</p>
          <div class="mt-4 text-[#E67E22] text-xl font-bold">★★★★★</div>
          <p class="mt-2 text-sm text-gray-600">Anna Mazur</p>
          <div class="absolute bottom-[0px] right-[0px] flex flex-col items-end">
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
          </div>
        </div>

        <!-- Testimonial 2 -->
        <div class="bg-white p-6 rounded-lg shadow-lg text-gray-900 relative">
          <div class="absolute top-[0px] left-[0px] flex flex-col">
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
          </div>
          <p class="text-lg font-medium">"The entire development process was incredibly fast, smooth, and trouble-free, allowing me to enjoy my new apartment without unnecessary delays."</p>
          <div class="mt-4 text-[#E67E22] text-xl font-bold">★★★★★</div>
          <p class="mt-2 text-sm text-gray-600">Sebastian Matejko</p>
          <div class="absolute bottom-[0px] right-[0px] flex flex-col items-end">
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
          </div>
        </div>

        <!-- Testimonial 3 -->
        <div class="bg-white p-6 rounded-lg shadow-lg text-gray-900 relative">
          <div class="absolute top-[0px] left-[0px] flex flex-col">
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
          </div>
          <p class="text-lg font-medium">"I love simple, minimalist interiors, but it was hard for me to design them on my own. The interior designer from ProjectSpot created a project that perfectly reflects my lifestyle. The cooperation was smooth, and the implementation was quick. I'm thrilled!"</p>
          <div class="mt-4 text-[#E67E22] text-xl font-bold">★★★★★</div>
          <p class="mt-2 text-sm text-gray-600">Adrianna Stańczak</p>
          <div class="absolute bottom-[0px] right-[0px] flex flex-col items-end">
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
          </div>
        </div>
      </div>

      <!-- Stats -->
      <div class="mt-16 text-center">
        <h3 class="text-2xl font-bold text-gray-900 mb-8">Our Achievements</h3>
        <div class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
          <!-- Stat 1 -->
          <div class="mx-auto flex flex-col items-center gap-y-4">
            <dt class="text-xl font-medium text-gray-700">Google rating average</dt>
            <dd class="text-4xl font-medium tracking-tight text-gray-900 sm:text-5xl">5/5</dd>
            <div class="w-16 h-[3px] bg-[#E9A53D] mx-auto mt-4"></div>
          </div>

          <!-- Stat 2 -->
          <div class="mx-auto flex flex-col items-center gap-y-4">
            <dt class="text-xl font-medium text-gray-700">Satisfied clients</dt>
            <dd class="text-4xl font-medium tracking-tight text-gray-900 sm:text-5xl">100%</dd>
            <div class="w-16 h-[3px] bg-[#E9A53D] mx-auto mt-4"></div>
          </div>

          <!-- Stat 3 -->
          <div class="mx-auto flex flex-col items-center gap-y-4">
            <dt class="text-xl font-medium text-gray-700">Number of reviews</dt>
            <dd class="text-4xl font-medium tracking-tight text-gray-900 sm:text-5xl">50+</dd>
            <div class="w-16 h-[3px] bg-[#E9A53D] mx-auto mt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.bg-white {
  background-color: #ffffff;
}

.text-gray-600 {
  color: #4b5563;
}

.text-gray-900 {
  color: #111827;
}
</style>
